import React, { useEffect } from 'react';
import { useStateValue } from '../StateProvider/StateProvider';
import './Checkout.css';
import CheckoutProduct from '../CheckoutProduct/CheckoutProduct';
import Subtotal from '../Subtotal/Subtotal';
import { getSelectedItemsTotal } from '../StateProvider/reducer';
import CurrencyFormat from 'react-currency-format';

export const getCheckboxes = () => {
  let checkboxes = [
    ...document.getElementsByClassName('checkoutProduct__checkbox'),
  ];
  return checkboxes;
};

function Checkout() {
  const [
    { cart, selectedCartItems, totalSelectedCartItems },
    dispatch,
  ] = useStateValue();

  const selectAllItems = () => {
    let checkboxes = getCheckboxes();
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked !== true) checkbox.checked = true;
    });
  };

  const deselectAllItems = (event) => {
    event.preventDefault();
    let checkboxes = getCheckboxes();
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked !== false) checkbox.checked = false;
    });
    dispatch({
      type: 'EMPTY_SELECTED_CART_ITEMS',
    });
  };

  useEffect(() => {
    selectAllItems();
  }, []);

  return (
    <div className="checkout">
      <div className="checkout__left">
        <img
          className="checkout__ad"
          src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
          alt=""
        />
        {cart?.length === 0 ? (
          <div>
            <h2>Your Shopping Cart is empty</h2>
            <p>
              You have no items in your cart. To buy one or more items, click
              "Add To Cart" next to the item.
            </p>
          </div>
        ) : (
          <div>
            <h1>Shopping Cart</h1>
            <a href="true" onClick={deselectAllItems}>
              Deselect All Items
            </a>
            <div className="checkout__priceLabelContainer">Price</div>
            <div className="checkout__productContainer">
              {cart.map((product, index) => (
                <CheckoutProduct
                  key={index}
                  id={product.item.id}
                  title={product.item.title}
                  image={product.item.image}
                  price={product.item.price}
                  rating={product.item.rating}
                  quantity={product.quantity}
                  description={product.description}
                />
              ))}
            </div>
            <div className="checkout__subtotalContainer">
              {selectedCartItems.length > 0 ? (
                <CurrencyFormat
                  renderText={(value) => (
                    <>
                      <p>
                        Subtotal ({totalSelectedCartItems} item
                        {totalSelectedCartItems > 1 ? 's' : ''}
                        ): <strong>{value}</strong>
                      </p>
                    </>
                  )}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  value={getSelectedItemsTotal(selectedCartItems)}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={'$'}
                />
              ) : (
                <p>No Price</p>
              )}
            </div>
          </div>
        )}
      </div>
      {cart.length > 0 && (
        <div className="checkout__right">
          <Subtotal />
        </div>
      )}
    </div>
  );
}

export default Checkout;
